import { buildErrorsFromMsgs } from '@core/js/utils/errorHandling';

export const BOPIS_CHANGE_STORE_LOAD_STORES = 'BOPIS_CHANGE_STORE_LOAD_STORES';
export const BOPIS_CHANGE_STORE_CLEAR = 'BOPIS_CHANGE_STORE_CLEAR';
export const BOPIS_CHANGE_STORE_SEARCH_DATA = 'BOPIS_CHANGE_STORE_SEARCH_DATA';
export const BOPIS_CHANGE_STORE_RESULT_DATA = 'BOPIS_CHANGE_STORE_RESULT_DATA';
export const BOPIS_FIND_STORES = 'BOPIS_FIND_STORES';

export function bopisChangeStoreLoadStores(stores, pools) {
    return {
        type: BOPIS_CHANGE_STORE_LOAD_STORES,
        payload: {
            stores: stores,
            pools: pools,
            msgs: []
        }
    };
}

export function bopisChangeStoreClear() {
    return {
        type: BOPIS_CHANGE_STORE_CLEAR
    };
}

export function bopisChangeStoreClearStores() {
    return bopisChangeStoreLoadStores(undefined, undefined); // eslint-disable-line no-undefined
}

export function bopisChangeStoresNoStoresFound() {
    return bopisChangeStoreLoadStores([], []);
}

export function bopisChangeStoresSearchData(formData, msgs) {
    const convertedMsgs = buildErrorsFromMsgs(msgs);

    return {
        type: BOPIS_CHANGE_STORE_SEARCH_DATA,
        payload: {
            data: formData,
            msgs: convertedMsgs
        }
    };
}

export function bopisChangeStoresResultData(formData, msgs) {
    const convertedMsgs = buildErrorsFromMsgs(msgs);

    return {
        type: BOPIS_CHANGE_STORE_RESULT_DATA,
        payload: {
            data: formData,
            msgs: convertedMsgs
        }
    };
}

export function bopisChangeStoresInvalidLocation() {
    return bopisChangeStoresSearchData({}, {
        generalErrors: ['INVALID_LOCATION']
    });
}

/**
 * @param {Object} payload      Redux action payload
 * @param {Object} payload.product Product to search
 * @param {Object} payload.location String of the location (city or zip, etc)
 * @param {Object} payload.distance Distance of search
 * @param {Object} component The component dispatching this action
 * @returns {Object} bopis find stores data
*/
export function bopisFindStores(payload, component) {
    return {
        type: BOPIS_FIND_STORES,
        payload: payload,
        meta: {
            component: component
        }
    };
}
